module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/why-use-vue-file-for-distribution-25.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/why-use-vue-file-for-distribution.md
// module id = 601
// module chunks = 179